var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6329_88339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5963 13.6211C25.1009 12.1163 27.4696 11.9776 29.0447 13.3019L30.1828 14.2606C31.4816 15.3537 31.6137 17.3241 30.4756 18.6605C29.8549 19.3785 28.9813 19.8296 28.0365 19.9197C24.3998 20.4096 20.5848 18.6572 16.5893 14.6613C12.5938 10.6655 10.8404 6.8491 11.3302 3.21323C11.3557 2.92875 11.4148 2.64829 11.5063 2.37774C11.7181 1.75623 12.092 1.20255 12.5894 0.773904C13.9267 -0.3632 15.8959 -0.232207 16.9889 1.06781L17.9465 2.20602C19.2728 3.77903 19.1352 6.14901 17.6306 7.65377L16.8138 8.46945C16.5961 8.68759 16.5248 9.01232 16.6311 9.30164C16.9283 10.114 17.6867 11.1289 18.9041 12.3464C20.1225 13.5649 21.1374 14.3223 21.9486 14.6206C22.2381 14.7267 22.5628 14.6549 22.7807 14.4368L23.5963 13.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 7,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 12,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-90 0.75 12)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6329_88339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateVideo);
export default __webpack_public_path__ + "static/media/create_video.737857a4ad528cf04c750bc2e16a58a7.svg";
export { ForwardRef as ReactComponent };